/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TipsIcon = ({ width = 24, height = 24, hidden = false, title = 'Tips' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M28.8 10.613A10.572 10.572 0 0 0 17.986.3a11.349 11.349 0 0 0-2.169.21A11.033 11.033 0 0 0 7.2 10.69C7.2 16.148 12 19.044 12 24v2h12v-2c0-5 4.8-8.048 4.8-13.387ZM12 28v2.367a1.5 1.5 0 0 0 .359.973l3.524 4.133a1.5 1.5 0 0 0 1.142.527h1.951a1.5 1.5 0 0 0 1.141-.527l3.525-4.133a1.5 1.5 0 0 0 .358-.973V28Z"
    />
  </svg>`;
};
